<template class="myBG">
    <v-container fluid>
        <v-layout row class="text-xs-center">
            <v-flex xs12 sm12 md12 lg12>
                <!-- <h4 class="">OBLO B&B</h4> -->
                <h1 class="display-3 font-weight-thin">UNDER CONSTRUCTION</h1>
                <v-btn outline color="info darken-3" target="_blank" href="https://www.booking.com/hotel/it/b-amp-b-oblo.it.html?label=opensearch-plugin;sid=5c8ee363ca4ab5972e39a058225d9889;dest_id=-114787;dest_type=city;dist=0;hapos=1;hpos=1;room1=A%2CA;sb_price_type=total;sr_order=popularity;srepoch=1565642366;srpvid=2645913f3866015f;type=total;ucfs=1&#hotelTmpl">
                    <v-icon class="info--text text--darken-3 mr-2">fas fa-calendar-check</v-icon>
                    Booking.com
                </v-btn>
                <br>
                <img class="myWip" src="@/assets/isometric.png" alt="wip">
            </v-flex>
        </v-layout>

        <v-layout row class="text-xs-center">
            <v-flex xs12 sm4 md4 lg4>
                <v-icon class="myIcon" large color="purple">email</v-icon>&nbsp;&nbsp;<label class="myInfo mb-2">info@oblobb.it</label>
            </v-flex>
            <v-flex xs12 sm4 md4 lg4>
                <v-icon class="myIcon" large color="purple">contact_phone</v-icon>&nbsp;&nbsp;<label class="myInfo mb-2">+39 3490699160</label>
            </v-flex>
            <v-flex xs12 sm4 md4 lg4>
                <v-icon class="myIcon" large color="purple">place</v-icon>&nbsp;&nbsp;<label class="myInfo mb-2">Piazza dei Martiri 3, 95131 Catania</label>
            </v-flex>
        </v-layout>

        <v-layout row class="text-xs-left">
            <v-flex>
                <a class="myLink" href="http://www.freepik.com">Designed by Freepik</a>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    
}
</script>

<style scoped>

.myLink{
    font-size: 8px;
    color: darkseagreen;
}

.myBG{
    background: rgb(255,255,255);
    background: -moz-radial-gradient(center, ellipse cover, rgb(255,255,255) 0%, rgb(246,246,246) 47%, rgb(237,237,237) 100%);
    background: -webkit-gradient(radial, center center, 0px, center center, 100%, color-stop(0%, rgb(255,255,255)), color-stop(47%, rgb(246,246,246)), color-stop(100%, rgb(237,237,237)));
    background: -webkit-radial-gradient(center, ellipse cover, rgb(255,255,255) 0%, rgb(246,246,246) 47%, rgb(237,237,237) 100%);
    background: -o-radial-gradient(center, ellipse cover, rgb(255,255,255) 0%, rgb(246,246,246) 47%, rgb(237,237,237) 100%);
    background: -ms-radial-gradient(center, ellipse cover, rgb(255,255,255) 0%, rgb(246,246,246) 47%, rgb(237,237,237) 100%);
    background: radial-gradient(ellipse at center, rgb(255,255,255) 0%, rgb(246,246,246) 47%, rgb(237,237,237) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ededed', GradientType=1 );
}

.myWip{
    object-fit: cover;
    width: auto;
    height: auto;
}

.myInfo{
    font-size: large;
}

.myIcon{
    position: relative;
    top: 8px;
}

@media only screen 
and (min-device-width : 375px) 
and (max-device-width : 667px) { 
    .myWip{
        width: 80%;
    }
}

@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px)  {
    .myWip{
        width: 70%;
    }
}
</style>